export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Editor/GPEditorLayerTypeIcon.png?92e2a0193e0a9ef0cc960c5e50a2b249";